import { render, staticRenderFns } from "./enumSetting.vue?vue&type=template&id=128e15e8&scoped=true&"
import script from "./enumSetting.vue?vue&type=script&lang=js&"
export * from "./enumSetting.vue?vue&type=script&lang=js&"
import style0 from "./enumSetting.vue?vue&type=style&index=0&id=128e15e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128e15e8",
  null
  
)

export default component.exports